import React from "react";

const moveInDate = (value) => {
  const parts = typeof value === "string" && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return parts ? `${parts[2]}/${parts[3]}/${parts[1]}` : "—";
};

export default function NoticeTenantSummary({ tenant, label, amount, caption }) {
  return <div className="notice-detail-summary">
    <div className="notice-detail-tenant">
      <div className="notice-detail-identity">
        <strong>{tenant.prop}-{tenant.unit}-{tenant.tenant}</strong>
        <span>{tenant.tenantName}</span>
      </div>
      <div className="notice-detail-meta">
        {tenant.address && <span className="notice-detail-address">{tenant.address}</span>}
        <span className="notice-detail-move-in">Move-in date <strong>{moveInDate(tenant.moveInDate)}</strong></span>
      </div>
    </div>
    <div className="notice-detail-balance">
      <div className="notice-detail-metric"><span className="notice-detail-label">{label}</span><strong>{amount}</strong></div>
      <span className="notice-detail-caption">{caption}</span>
    </div>
  </div>;
}
